module.exports = __webpack_public_path__ + "asset/image-no-calendar-537641c56c7d7b4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/image/no-calendar.svg
// module id = CNHz
// module chunks = 0